import React from 'react';
import PageBreadCrumb, { BreadCrumbModel } from '@components/ringil3/BreadCrumb/PageBreadCrumb.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';

export interface ComponentProps {
  items: BreadCrumbItemModel[];
  wrapper?: string;
}

export interface BreadCrumbItemModel {
  label: string;
  command?: (event: any) => void;
  disabled?: boolean | false;
  url?: string;
}

export interface BreadCrumbHomeModel {
  icon: string;
  url: string;
}

const BreadCrumbComponent: React.FC<ComponentProps> = ({ items, wrapper }) => {
  const menus = items.map(
    i =>
      ({
        label: i.label,
        action: isNotNullOrUndefined(i.url) ? i.url : i.command,
        disabled: i.disabled,
      } as BreadCrumbModel),
  );

  return (
    <div className={'flex flex-col gap-3 h-[4.5rem] py-4 max-md:pb-0 border-0 md:border-b border-solid justify-center border-content-tertiary mb-4'}>
      <PageBreadCrumb model={menus} />
    </div>
  );
};

export default BreadCrumbComponent;
